import { lazy } from 'react'

export const EmailVariant3 = lazy(() => import('./EmailVariant3'))
